<template>
  <div class="section section-signup" :style="
    'background-image: url(' +
    myTheme.home_section_background_image +
    '); background-size: cover; background-position: top center; min-height: 700px;'
  " v-loading.fullscreen.lock="isLoading" element-loading-background="rgba(256, 256, 256, 0.6)">
    >
    <div class="dark-overlay"></div>
    <el-alert v-if="showError" :title="$t('message.login_unauthenticated')" type="error" effect="dark">
    </el-alert>
    <div class="container">
      <div class="row">
        <cards class="card-signup" style="margin-top: 50px" header-classes="text-center"
          :style="{ color: myTheme.topMenu.normal.color }">
          <template slot="header">
            <h3 class="card-title title-up">
              {{ $t("text.welcome_to") }} <br />
              {{ business.name }}
            </h3>
            <div class="social-line">
              <el-image class="photo" :src="myTheme.home_section_logo_image">
                <div slot="placeholder" class="image-slot">
                  <i class="fa fa-circle-o-notch fa-spin fa-1x fa-fw"></i>
                </div>
                <div slot="error" class="image-slot text">
                  <img class="photo" src="img/logo-error-200.png" />
                </div>
              </el-image>
            </div>
          </template>
          <template>
            <!--social-login 
              class="login-social-account mb-2"
              :loginLabel="$t('button.continue_with_apple')"
              icon="k-icon-applepay"
              @login="loginSocialAccount"
              provider="apple"
              :app-id="subdomain.get()"
            />
            <social-login
              class="login-social-account mb-2"
              :loginLabel="$t('button.continue_with_facebook')"
              icon="k-icon-facebook-1"
              @login="loginSocialAccount"
              provider="facebook"
              :isConnected="isConnected.facebook"
              :app-id="facebookAppId"
              @login-progress="setIsLoading"
              :is-web-view="IsWebView()"
            />
            <social-login :is-web-view="IsWebView()"
              class="login-social-account"
              :loginLabel="$t('button.continue_with_google')"
              @login="loginSocialAccount"
              provider="google"
            /-->

            <p class="text-center my-3 font-weight-bold">
              {{ $t("text.sign-with-email") }}
            </p>
            <ValidationProvider rules="required|email" ref="emailValidator" v-slot="{ errors }">
              <fg-input type="email" v-model.lazy="email" :placeholder="$t('input.placeholder.enter_your_email')"
                class="no-border" :error="errors[0]" inputClasses="white-input">
              </fg-input>
            </ValidationProvider>

            <ValidationProvider rules="required" ref="passwordValidator" v-slot="{ errors }">
              <div class="input-group form-group center-align" role="group">
                <fg-input class="no-border" type="password" ref="password" id="password"
                  style="width: 100%; padding-right: 1px" v-model.lazy="password" :error="errors[0]"
                  :placeholder="$t('input.placeholder.enter_password')" inputClasses="white-input"
                  v-on:keyup.enter="login()">
                </fg-input>
                <n-button type="primary" @click="switchVisability()" round icon class="add-on-input icon-eye"
                  v-bind:style="myTheme.customizeButton">
                  <span id="pass-status" class="fa fa-fw fa-eye"></span>
                </n-button>
              </div>
            </ValidationProvider>

            <div id="forgot-password">
              <p class="mb-0">{{ $t("text.forgot_password") }}</p>
              <n-button class="mt-0" type="primary" @click="goToForgottenPassword()" link>
                {{ $t("button.click_here") }}</n-button>
            </div>
          </template>
          <div class="login-btns">
            <n-button class="btn btn-primary btn-md btn-round w-100" v-bind:style="myTheme.customizeButton"
              :disabled="!isComplete" @click="login()">{{
                isComplete
                ? $t("button.log_in")
                : $t("button.fill_data_to_login")
              }}</n-button>
          </div>
          <div class="login-btns">
            <n-button class="btn btn-primary btn-md btn-round w-100" :style="myTheme.registrationButtons"
              @click.native="$router.push('/register')">{{ $t("button.register") }}
            </n-button>
          </div>
          <div class="pt-2 text-center w-100">
            <img src="img/whatthefork-powered-black.png" alt="What The Fork" style="width:180px" />
          </div>
        </cards>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import router from "../router";
import { Cards, FormGroupInput, Button } from "@/components";
import { ValidationProvider } from "vee-validate";
import { subdomain } from "@/utilities";
import { IsWebView } from "@/utilities/helper";
import onMesssageMixin from "@/mixins/onMesssageMixin";
import { isIOS } from "mobile-device-detect";

export default {
  name: "login",
  mixins: [onMesssageMixin],
  bodyClass: "login-page",
  computed: {
    isComplete() {
      return this.email && this.password;
    },
  },
  components: {
    Cards,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    ValidationProvider,
  },
  data() {
    return {
      email: "",
      password: "",
      showError: false,
      token: "",
      isLoading: false,
      fullPage: true,
      passwordField: "",
      emailError: false,
      pswError: false,
      isIOS,
      isConnected: {
        facebook: false,
        apple: false,
        google: false,
      },
      FB: undefined,
      facebookAppId: process.env.VUE_APP_FACEBOOK_APP_ID,
      subdomain
    };
  },
  created() {
    this.$root.$on("SOCIAL_LOGIN_FIRED", data => {
      this.login(data)
    })
  },
  methods: {
    ...mapActions('userStore', ["authRequest", "authSocialRequest", "saveOneSignalUserId"]),
    goToRegister() {
      router.push({ name: "register" });
    },
    async login(payload) {
      // check if the user provide a valide email
      this.showError = false;
      this.isLoading = true;

      if (!payload) {
        const isEmailValid = await this.$refs.emailValidator.validate();
        if (!isEmailValid.valid) {
          this.isLoading = false;
          return
        }
      }

      try {
        const response = payload
          ? await this.authSocialRequest(payload)
          : await this.authRequest({
            email: this.email,
            password: this.password,
          });
        if (IsWebView()) {
          this.sendMessage({ userId: response.data.id });
          this.saveOneSignalUserId(response.data.id);
        }
        this.isLoading = false;
        this.$router.push(this.$route.query.redirect || "/");
      } catch (e) {
        //--- check if the user is coming from the old system :
        switch (e.data?.error?.status_code) {
          case 1000:
            //--- Display a popup to the user to explain the raison why he can't login
            this.displayResetPasswordAlert(this.$t("message.new_password_required"), this.$t("message.new_login_security"));
            break;
          case 1001:
            this.displaySuspendAlert();
            break;
          default:
            this.showError = true;
            break;
        }
        this.isLoading = false;
      }
    },
    switchVisability() {
      this.passwordField = document.querySelector("#password");
      var passStatus = document.getElementById("pass-status");
      if (this.passwordField.getAttribute("type") === "password") {
        this.passwordField.setAttribute("type", "text");
        passStatus.className = "fa fa-eye-slash";
      } else {
        this.passwordField.setAttribute("type", "password");
        passStatus.className = "fa fa-eye";
      }
    },
    goToForgottenPassword() {
      router.push({ name: "forgotten-password" });
    },
    displayResetPasswordAlert(title, message) {
      //-- TODO : display a modal with message and ok button
      let full_message =
        "<div><i class='k-icon-location-1 big-icon' style='color:" +
        this.staticColor.ratingOkey +
        "' ></i></div>";
      if (title)
        full_message += "<div class='dg-content-title'>" + title + "</div>";
      if (message) {
        full_message +=
          "<div class='dg-content-body-text'>" + message + "</div>";
      }
      let self = this;
      let options = {
        html: true,
        okText: this.$t("button.reset_password"),
        cancelText: this.$t("button.ok"),
        animation: "fade",
        type: "basic",
        backdropClose: false,
        customClass: "confirm login-pop-up",
      };
      this.$dialog
        .confirm(full_message, options)
        .then(function () {
          self.Loading = true;
          self
            .forgotPasswordRequest(self.email)
            .then(() => {
              //--- display mesage email sent
              let alert_options = {
                html: true,
                okText: this.$t("button.ok"),
                animation: "fade",
                type: "basic",
                backdropClose: false,
                customClass: "confirm",
              };

              let alert_message =
                "<div><i class='k-icon-location-1 big-icon' style='color:" +
                self.staticColor.ratingOkey +
                "' ></i></div>";
              alert_message += `<div class='dg-content-body-text'>${this.$t(
                "message.password_email_instruction_sent"
              )}</div>`;
              self.$dialog.alert(alert_message, alert_options);
              self.Loading = false;
            })
            .catch((e) => {
              this.captureException(e);
            });
        })
        .catch(() => { });
    },
    displaySuspendAlert() {
      //-- TODO : display a modal with message and ok button
      let template =
        `<div><i class='fas fa-frown big-icon' style='color:${this.staticColor.red}' ></i></div>
        <div class='dg-content-title'>Account Suspended</div>
        <div class='dg-content-body-text pt-2'>
        <p>${this.$t("message.user_suspended")}<p>
        <p>For more information please <a href="mailTo:info@whatthefork.co.uk">contact us</a><p></div>`;
      let options = {
        html: true,
        okText: this.$t("button.ok"),
        animation: "fade",
        type: "basic",
        backdropClose: false,
        customClass: "confirm login-pop-up",
      };
      this.$dialog.alert(template, options)
    },
    /*******Facebook Login **********/
    setIsLoading(value) {
      this.$set(this, "isLoading", value);
    },
    getFacebookUserData() {
      const self = this;
      this.FB.api(
        "/me",
        "GET",
        { fields: "id,first_name,last_name,name,email,picture.type(large)" },
        function (user) {
          self.login({
            provider_name: "facebook",
            provider_id: user.id,
            email: user.email ? user.email : `${user.id}@urapppro.com`,
            first_name: user.first_name ? user.first_name : "",
            last_name: user.last_name ? user.last_name : "",
            avatar:
              user.picture && user.picture.data ? user.picture.data.url : null,
          });
        }
      );
    },
    loginSocialAccount(payload) {
      if (!payload) return;

      if (payload.provider === "facebook" && payload.isConnected) {
        this.FB = payload.FB;
        this.getFacebookUserData();
      } else if (payload.isConnected) {
        this.login(payload.user);
      }
    },
  },
  beforeDestroy() {
    this.$root.$off("SOCIAL_LOGIN_FIRED")
  }
};
</script>
<style scoped>
.login-page .el-alert {
  position: fixed;
  width: 100%;
  z-index: 997;
  margin-top: 33px;
}

.card-signup {
  background: transparent;
  -webkit-box-shadow: 0 0 0 0;
  box-shadow: 0 0 0 0;
}

#forgot-password {
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}

#forgot-password button {
  color: #ffffff;
}

.login-btns {
  text-align: center;
}

.center-align span {
  margin: auto;
}

.form-group.input-group {
  padding: 0;
}
</style>

<style lang="scss">
.login-facebook {
  button[data-v-0af1f3c3] {
    position: relative;
    padding: 0 0px 0px 46px;
    border: none;
    line-height: 0px;
    font-size: 16px;
    color: #fff;
    min-width: 225px;
    background-image: none;
  }
}
</style>